export default __webpack_public_path__ + "static/media/categoryDes.5a41f4d8.jpg";